"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import Lenis from "lenis";
export function SmoothScroll() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
  return null;
}
function _temp() {
  if (typeof window === "undefined") {
    return;
  }
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    return;
  }
  const lenis = new Lenis({
    duration: 1.2,
    lerp: 0.1,
    smoothWheel: true
  });
  let raf = 0;
  const tick = time => {
    lenis.raf(time);
    raf = requestAnimationFrame(tick);
  };
  raf = requestAnimationFrame(tick);
  return () => {
    cancelAnimationFrame(raf);
    lenis.destroy();
  };
}